import React from 'react'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'
import Ingredient from './ingredient'
import IngredientsList from './ingredientsList'

import IngredientLoader from './loader'



const Ingredients = props => <Switch>
  <Route
    path="/ingredients"
    exact
    component={IngredientsList}
  />
  <Route
    path="/ingredients/:ingredientId"
    render={
      ({ match: { params: { ingredientId } } }) =>
        <IngredientLoader
          ingredientId={ingredientId}
          key={ingredientId}
          component={() => <Ingredient key={`i_${ingredientId}`} />}
        />
    }
  />
  <Redirect to="/ingredients"/>
</Switch>



export default withRouter(Ingredients)
